const messages = {
  pt: {
    translations: {
      validation: {
        required: "Obrigat\u00f3rio",
        invalid: "Inv\u00e1lido",
        tooShort: "Muito curto",
        tooLong: "Muito longo",
      },
      weekdays: {
        monday: "Segunda-feira",
        tuesday: "Ter\u00e7a-feira",
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "S\u00e1bado",
        sunday: "Domingo",
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usu\u00e1rio criado com sucesso! Fa\u00e7a seu login!!!.",
          fail: "Erro ao criar usu\u00e1rio. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "J\u00e1 tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "N\u00e3o tem uma conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
          forcedLogout: "Sua sess\u00e3o foi encerrada por um administrador.",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conex\u00f5es",
        presence: {
          online: "Online",
          away: "Ausente",
          offline: "Offline",
        },
        sipStatus: {
          unavailable: "Indisponivel",
          registered: "Registrado",
          offline: "Offline",
        },
        toasts: {
          deleted: "Conex\u00e3o com o WhatsApp exclu\u00edda com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Voc\u00ea tem certeza? Essa a\u00e7\u00e3o n\u00e3o pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Voc\u00ea precisar\u00e1 ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sess\u00e3o do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado \u00e0 internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no bot\u00e3o 'QR CODE' e leia o QR Code com o seu celular para iniciar a sess\u00e3o",
          },
          connected: {
            title: "Conex\u00e3o estabelecida!",
          },
          timeout: {
            title: "A conex\u00e3o com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado \u00e0 internet e o WhatsApp esteja aberto, ou clique no bot\u00e3o 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "\u00daltima atualiza\u00e7\u00e3o",
          default: "Padr\u00e3o",
          actions: "A\u00e7\u00f5es",
          session: "Sess\u00e3o",
        },
        extras: {
          searchPlaceholder: "Pesquisar por nome",
          filters: "Filtros",
          add: "Adicionar",
          disconnectedTitle: "Conex\u00f5es desconectadas involuntariamente",
          disconnectedDescription: "Algumas conex\u00f5es foram desconectadas. Isso pode acontecer por sess\u00e3o expirada, instabilidade ou perda temporaria de acesso.",
          viewConnections: "Ver conex\u00f5es",
          activeTab: "Ativas",
          archivedTab: "Arquivadas",
          connectionId: "ID da conex\u00e3o: #{{id}}",
          noDefaultQueue: "Sem fila padr\u00e3o",
          emptyArchived: "Nenhuma conex\u00e3o arquivada.",
          empty: "Nenhuma conex\u00e3o encontrada.",
          showingResults: "Mostrando {{visible}} de {{total}} resultados",
          pageLabel: "Página 1 de 1",
          view: "Visualizar",
          archive: "Arquivar",
          unarchive: "Restaurar",
          delete: "Deletar",
          breadcrumb: "Conex\u00f5es > Adicionar conex\u00e3o",
          addConnectionTitle: "Adicionar conex\u00e3o",
          available: "Disponível",
          availableCount: "{{count}} disponível",
          limitReached: "Limite atingido",
          createdConnection: "{{count}} conex\u00e3o criada.",
          createdConnections: "{{count}} conex\u00f5es criadas.",
          contractToUse: "Contrate essa conex\u00e3o para comecar a usa-la.",
          usage: "Uso: {{count}}{{limit}}",
          newConnection: "Nova conex\u00e3o",
          request: "Solicitar",
          blockedUnavailable: "Conex\u00e3o indisponivel",
          blockedLimitTitle: "Limite atingido para esta conex\u00e3o",
          blockedNotContractedTitle: "Esta conex\u00e3o não esta inclusa no seu plano",
          blockedComingSoonTitle: "Esta conex\u00e3o ainda esta em prepara\u00e7\u00e3o",
          blockedLimitMessage: "Seu plano contempla esta conex\u00e3o, mas o limite contratado já foi atingido. Fale com o suporte para ampliar a capacidade.",
          blockedNotContractedMessage: "Parece que seu plano atual não contempla essa conex\u00e3o. Entre em contato com o suporte e descubra como habilita-la na sua conta.",
          blockedComingSoonMessage: "Esta conex\u00e3o esta contratada no pacote, mas o conector ainda não esta disponível nesta versão.",
          talkSupport: "Falar com suporte",
          archiveTitle: "Arquivar conex\u00e3o",
          archiveMessage: "Esta conex\u00e3o saira da lista de ativas e ficara disponível na aba Arquivadas.",
          unarchiveTitle: "Restaurar conex\u00e3o",
          unarchiveMessage: "Esta conex\u00e3o voltara para a lista de conex\u00f5es ativas.",
          archivedSuccess: "Conex\u00e3o arquivada.",
          restoredSuccess: "Conex\u00e3o restaurada.",
          didMissing: "DID não informado",
          metaIdMissing: "ID Meta não informado",
          numberMissing: "Número não informado",
          configured: "Configurado",
          configure: "Configurar",
          connected: "Conectado",
          connecting: "Conectando",
          connect: "Conectar",
          reconnect: "Reconectar",
          disconnected: "Desconectado",
          pairing: "Pareando",
          unstable: "Instavel",
          pending: "Pendente",
          groupActive: "Ativo",
          groupInactive: "Desativado"
        },
      },
      apiTools: {
        introTitle: "Ferramentas de integra\u00e7\u00e3o operacional",
        introText: "Configure e execute ações via API diretamente no atendimento, com seguranca e auditoria.",
        httpTitle: "Ações HTTP",
        httpText: "Cadastro de ações como 2a via, desbloqueio e abertura de O.S.",
        permissionsTitle: "Permissões",
        permissionsText: "Controle por usu\u00e1rio, com restrição por a\u00e7\u00e3o.",
        auditTitle: "Auditoria",
        auditText: "Registro de execuções para rastrear quem executou, quando e o resultado.",
        wabaIntro: "Configure as credenciais oficiais por conex\u00e3o e valide a conectividade com a Cloud API da Meta.",
        loadingConnections: "Carregando conex\u00f5es...",
        noWaba: "Nenhuma conex\u00e3o WABA cadastrada ainda. Crie uma conex\u00e3o do tipo WABA em Conex\u00f5es > Adicionar WhatsApp.",
        config: "Configura\u00e7\u00e3o",
        templates: "Templates",
        calls: "Chamadas",
        whatsappConnection: "Conex\u00e3o WhatsApp",
        enableWaba: "Habilitar WABA nesta conex\u00e3o",
        generate: "Gerar",
        loading: "Carregando...",
        saving: "Salvando...",
        testing: "Testando...",
        saveWaba: "Salvar WABA",
        testConnection: "Testar conex\u00e3o",
        updateList: "Atualizar lista",
        createTemplate: "Criar template",
        updateCalls: "Atualizar chamadas",
        close: "Fechar",
        reload: "Recarregar"
      },
      companyPage: {
        title: "Empresa",
        refresh: "Atualizar",
        operationTitle: "Opera\u00e7\u00e3o da equipe",
        operationDescription: "Centralize o comportamento operacional da empresa em um único lugar.",
        saveOperation: "Salvar opera\u00e7\u00e3o",
        awayMinutes: "Tempo para considerar ausente (minutos)",
        awayMinutesHelp: "Depois desse tempo sem atividade, o atendente passa para ausente.",
        subjectRequired: "Assunto do chamado obrigatório",
        subjectRequiredHelp: "Quando ativado, o atendente precisa informar o assunto antes de enviar mensagens no chamado.",
        autoResumeSla: "Retomar SLA automaticamente",
        autoResumeSlaHelp: "Quando ativado, o contador Tempo SLA retoma automaticamente quando o cliente responder.",
        sharedQueue: "Permitir fila compartilhada para atendentes",
        sharedQueueHelp: "Quando ativado, usu\u00e1rios do perfil atendente podem ver chamados da propria fila, mesmo sem estarem atribuidos a eles.",
        loadPreviousTicketMessages: "Carregar mensagens de atendimentos anteriores",
        loadPreviousTicketMessagesHelp: "Ao rolar para cima na conversa, continua carregando as mensagens dos atendimentos anteriores do mesmo contato. Pode ser liberado ou negado por usuário no cadastro.",
        previousTicketMessagesPageSize: "Mensagens por carregamento",
        previousTicketMessagesPageSizeHelp: "Entre 10 e 100. Vale para toda a conversa, não só para o histórico.",
        pendingCloseByUser: "Permitir que atendentes fechem chamados em aguardando",
        pendingCloseByUserHelp: "Quando ativado, atendentes podem fechar chamados que ainda estao em aguardando, sem precisar aceitar antes. Quando desativado, apenas admins podem fazer isso.",
        previewPending: "Permitir espiar chamados aguardando",
        previewPendingHelp: "Quando ativado, atendentes podem abrir a previa de chamados aguardando sem aceitar o atendimento.",
        recordingsPlayback: "Permitir que atendentes oucam gravações",
        recordingsPlaybackHelp: "Quando ativado, usu\u00e1rios atendentes podem reproduzir gravações de chamadas nos tickets.",
        blockedTitle: "Contatos bloqueados",
        blockedDescription: "Defina a mensagem e a a\u00e7\u00e3o automática para contatos e grupos marcados como bloqueados.",
        saveBlocked: "Salvar bloqueio",
        featureDisabled: "Recurso desabilitado no superadmin para esta empresa.",
        blockedMessage: "Mensagem para contato bloqueado",
        blockedMessageHelp: "Mensagem enviada automaticamente quando o contato ou grupo bloqueado enviar mensagem.",
        blockedAction: "Ação para contato bloqueado",
        closeTicket: "Fechar o chamado",
        keepPending: "Manter na fila",
        blockedCloseSubject: "Assunto ao fechar chamado bloqueado",
        noSubject: "Sem assunto",
        businessHoursTitle: "Hor\u00e1rio de atendimento",
        businessHoursDescription: "Defina o expediente operacional da empresa, a mensagem de aus\u00eancia e o comportamento desejado fora do hor\u00e1rio ou em feriados.",
        holidays: "Cadastrar feriados",
        saveHours: "Salvar hor\u00e1rio",
        outOfHoursMessage: "Mensagem de aus\u00eancia fora do hor\u00e1rio",
        outOfHoursMessageHelp: "Essa mensagem e enviada automaticamente fora do expediente. Em feriados, a mensagem cadastrada no feriado tem prioridade.",
        outOfHoursAction: "Quando chamarem fora do hor\u00e1rio ou em feriado",
        day: "Dia",
        active: "Ativo",
        start: "In\u00edcio",
        end: "Fim",
        connectionsTitle: "Conex\u00f5es da empresa",
        connectionsDescription: "Administre fila padr\u00e3o, grupos e comportamento principal de cada conex\u00e3o.",
        newConnection: "Nova conex\u00e3o",
        editConnection: "Editar conex\u00e3o",
        defaultConnection: "Conex\u00e3o padr\u00e3o",
        allowGroups: "Atender grupos",
        defaultQueue: "Fila padr\u00e3o da conex\u00e3o",
        noDefaultQueue: "Sem fila padr\u00e3o",
        availableQueues: "Filas disponíveis nesta conex\u00e3o:",
        noLinkedQueue: "nenhuma fila vinculada",
        routedToDefaultQueue: "Novos tickets dessa conex\u00e3o serao direcionados para a fila padr\u00e3o.",
        keepCurrentQueueBehavior: "Sem fila padr\u00e3o, o comportamento atual de escolha de fila e mantido.",
        saveConnection: "Salvar conex\u00e3o",
        activeDays: "{{count}} dias ativos",
        noConfiguredDay: "Nenhum dia configurado"
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padr\u00e3o",
          farewellMessage: "Mensagem de despedida"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sess\u00e3o",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato exclu\u00eddo com sucesso!",
          imported: "Importa\u00e7\u00e3o de contatos do WhatsApp conclu\u00edda.",
          invalidImportFile: "Selecione um arquivo CSV ou TXT para importar.",
          fileImported:
            "Importa\u00e7\u00e3o conclu\u00edda. Importados: {{imported}} | Duplicados: {{skippedDuplicates}} | Inv\u00e1lidos: {{skippedInvalid}}.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados ser\u00e3o perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          importPhone: "Importar WhatsApp",
          importFile: "Importar CSV/TXT",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          personType: "PF/PJ",
          document: "CPF/CNPJ",
          email: "Email",
          actions: "A\u00e7\u00f5es",
          viewHistory: "Ver hist\u00f3rico do contato",
        },
        overview: {
          title: "Hist\u00f3rico do contato",
          contactMeta: "N\u00famero: {{number}} | Email: {{email}}",
          ticketsTitle: "Chamados do contato",
          noTickets: "Nenhum chamado encontrado para este contato.",
          noSubject: "Sem assunto",
          close: "Fechar",
          metrics: {
            total: "Total de chamados",
            open: "Em atendimento",
            pending: "Aguardando",
            closed: "Fechados",
          },
          status: {
            open: "Em atendimento",
            pending: "Aguardando",
            closed: "Fechado",
          },
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informa\u00e7\u00f5es adicionais",
          name: "Nome",
          number: "N\u00famero do Whatsapp",
          email: "Email",
          personType: "Tipo de cadastro",
          document: "CPF/CNPJ",
          documentHelp: "Informe apenas o CPF ou CNPJ do contato.",
          personTypeOptions: {
            notInformed: "N\u00e3o informado",
            pf: "PF",
            pj: "PJ",
          },
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informa\u00e7\u00e3o",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta R\u00e1pida",
          edit: "Editar Resposta R\u00e1pida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta R\u00e1pida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta R\u00e1pida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de sauda\u00e7\u00e3o",
          description: "Descri\u00e7\u00e3o da fila",
          tags: "Tags da fila",
          variablesHelp: "Vari\u00e1veis: {{name}} e {{protocol}}",
          businessHoursTitle: "Hor\u00e1rio por fila",
          useOwnBusinessHours: "Usar hor\u00e1rio pr\u00f3prio para esta fila",
          outOfHoursMessage: "Mensagem fora do hor\u00e1rio da fila",
          outOfHoursMessageHelp: "Se vazio, usa a mensagem de aus\u00eancia da empresa.",
          outOfHoursAction: "A\u00e7\u00e3o fora do hor\u00e1rio da fila",
          keepPending: "Manter na fila",
          closeTicket: "Fechar o chamado",
          day: "Dia",
          active: "Ativo",
          start: "In\u00edcio",
          end: "Fim",
        },
          buttons: {
            okAdd: "Adicionar",
            okEdit: "Salvar",
            cancel: "Cancelar",
          },
          success: "Fila salva com sucesso.",
        },
      extensionModal: {
        title: {
          add: "Adicionar ramal",
          edit: "Editar ramal",
        },
        form: {
          extension: "Ramal SIP",
          extensionValidation: "Use apenas numeros (2 a 10 digitos)",
          zoiperUserHint: "Login Zoiper: {{value}}",
          label: "Descri\u00e7\u00e3o",
          user: "Atendente",
          unassigned: "Sem atendente",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          sip: "SIP",
          sipOnline: "Online",
          sipOffline: "Offline",
          sipUnavailable: "Indispon\u00edvel",
          sipUnqualified: "N\u00e3o qualificado",
        },
        summary: {
          label: "Ramais",
          unlimited: "Ilimitado",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Ramal salvo com sucesso.",
      },
      userModal: {
        title: {
          add: "Adicionar usu\u00e1rio",
          edit: "Editar usu\u00e1rio",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          language: "Idioma",
          languageOptions: {
            pt: "Portugu\u00eas",
            en: "Ingl\u00eas",
            es: "Espanhol",
          },
          whatsapp: "Conex\u00e3o Padr\u00e3o",
          sipUser: "Conta SIP",
          sipStatus: "Status SIP",
          sipPassword: "Senha SIP",
          enableSip: "Habilitar SIP",
          enableWabaCalling: "Permitir chamadas WABA",
          enableWabaCallingHelp:
            "Permite exibir o bot\u00e3o Ligar nos tickets WABA deste usu\u00e1rio.",
          internalChatDeleteDirect: "Apagar conversa individual do chat interno",
          internalChatDeleteDirectHelp:
            "Apagar remove a conversa e todas as mensagens para os dois lados, sem como desfazer. Sem esta permissão o usuário ainda pode sair da conversa, que apenas limpa a lista dele.",
          internalChatDeleteGroup: "Apagar grupo do chat interno",
          internalChatDeleteGroupHelp:
            "Apagar remove o grupo e o histórico para todos os integrantes, sem como desfazer.",
          internalChatDeleteAdminHelp:
            "Administrador já pode apagar conversas do chat interno pelo cargo.",
          queueVisibility: "Ver chamados das filas dele",
          queueVisibilityCompany: "Seguir a configuração da empresa",
          queueVisibilityAllow: "Pode ver",
          queueVisibilityDeny: "Não pode ver",
          queueVisibilityHelp:
            "Vale para os chamados das filas em que o usuário está, inclusive os de outro atendente. Seguir a empresa usa a opção geral de Configurações; as outras duas valem só para este usuário.",
          queueVisibilityAdminHelp:
            "Administrador já enxerga todos os chamados da empresa pelo cargo.",
          previousTicketMessages: "Carregar mensagens de atendimentos anteriores",
          previousTicketMessagesHelp:
            "Ao rolar para cima na conversa, continua carregando as mensagens dos atendimentos anteriores do mesmo contato. Seguir a empresa usa a opção geral de Configurações.",
          supervisorMode: "Modo supervisor",
          supervisorModeHelp:
            "Libera permissões operacionais de supervisão sem acesso ao menu de administra\u00e7\u00e3o.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usu\u00e1rio salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para come\u00e7ar a conversar.",
      },
      ticketsManager: {
        tabs: {
          private: "Individuais",
          group: "Grupos",
        },
        buttons: {
          newTicket: "Novo",
          search: "Busca",
          filters: "Filtros",
        },
        activeFiltersSummary: {
          singular: "{{count}} filtro ativo",
          plural: "{{count}} filtros ativos",
        },
        connectionAlert: {
          notifyAdmin: "Avise um administrador.",
          checkConnections: "Verifique as conex\u00f5es.",
          noConnections: "A empresa est\u00e1 sem conex\u00e3o WhatsApp configurada.",
          qrcode: "H\u00e1 conex\u00e3o WhatsApp aguardando QR Code.",
          connecting: "A conex\u00e3o WhatsApp est\u00e1 inst\u00e1vel no momento.",
          inactive: "A empresa est\u00e1 sem conex\u00e3o WhatsApp ativa.",
        },
        filters: {
          title: "Filtros avan\u00e7ados",
          ticketId: "N\u00famero do atendimento",
          ticketIdPlaceholder: "Ex.: 26385",
          subtitle:
            "Refine a opera\u00e7\u00e3o por fila, atendente, conex\u00e3o, data e tags sem perder a vis\u00e3o da lista.",
          status: "Status",
          statusOptions: {
            active: "Ativos",
            open: "Atendendo",
            pending: "Aguardando",
            closed: "Resolvidos",
          },
          agent: "Atendente",
          connection: "Conex\u00e3o",
          date: "Data",
          all: "Todos",
          allFemale: "Todas",
          hint:
            "Combine fila, atendente, conex\u00e3o, data e tags para chegar mais r\u00e1pido na conversa certa.",
          clear: "Limpar",
          cancel: "Cancelar",
          apply: "Aplicar",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
        noQueue: "Sem fila",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que voc\u00ea estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usu\u00e1rios",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conex\u00e3o",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conex\u00e3o",
        noOptions: "Nenhum usu\u00e1rio encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conex\u00e3o que est\u00e1 sendo utilizada atualmente.",
        confirmations: {
          closePendingWithoutAccept:
            "Deseja fechar sem iniciar atendimento?",
        },
        buttons: {
          accept: "Aceitar",
          closePending: "Fechar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          profile: "Meu Perfil",
          companies: "Empresas",
          announcements: "Avisos",
          backups: "Backups",
          debugLogs: "Logs do sistema",
          dashboard: "Dashboard",
          attendance: "Atendimento",
          attendanceBadgeUnread: "{{total}} com mensagem não lida",
          attendanceBadgePending: "{{total}} aguardando atendimento",
          internalChat: "Chat Interno",
          internalTickets: "Tickets internos",
          attendances: "Atendimentos",
          monitoring: "Monitoramento",
          company: "Empresa",
          connections: "Conex\u00f5es",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas R\u00e1pidas",
          queues: "Filas",
          extensions: "Ramais",
          tags: "Tags",
          ticketSubjects: "Assuntos",
          administration: "Administra\u00e7\u00e3o",
          users: "Usu\u00e1rios",
          settings: "Configura\u00e7\u00f5es",
        },
        appBar: {
          language: {
            label: "Trocar idioma",
            options: {
              pt: "Portugu\u00eas",
              en: "Ingl\u00eas",
              es: "Espanhol",
            },
          },
          sound: {
            enable: "Ativar sons de notifica\u00e7\u00e3o",
            disable: "Silenciar sons de notifica\u00e7\u00e3o",
          },
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notifica\u00e7\u00e3o.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de sauda\u00e7\u00e3o",
          description: "Descri\u00e7\u00e3o",
          tags: "Tags",
          businessHours: "Hor\u00e1rio da fila",
          actions: "A\u00e7\u00f5es",
        },
        businessHours: {
          own: "Pr\u00f3prio",
          company: "Empresa",
        },
          buttons: {
            add: "Adicionar fila",
          },
          toasts: {
            deleted: "Fila exclu\u00edda com sucesso.",
          },
          confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Voc\u00ea tem certeza? Essa a\u00e7\u00e3o n\u00e3o pode ser revertida! Os tickets dessa fila continuar\u00e3o existindo, mas n\u00e3o ter\u00e3o mais nenhuma fila atribu\u00edda.",
        },
      },
      extensions: {
        title: "Ramais SIP",
        zoiperHint: "Login no Zoiper: c{empresa}-{ramal}. Exemplo: c2-1001.",
        table: {
          extension: "Ramal",
          zoiperUser: "Login Zoiper",
          label: "Descri\u00e7\u00e3o",
          user: "Atendente",
          status: "Status",
          actions: "Ações",
          unassigned: "Sem atendente",
          active: "Ativo",
          inactive: "Inativo",
          sip: "SIP",
          sipOnline: "Online",
          sipOffline: "Offline",
          sipUnavailable: "Indispon\u00edvel",
          sipUnqualified: "N\u00e3o qualificado",
        },
        summary: {
          label: "Ramais",
          unlimited: "Ilimitado",
        },
        buttons: {
          add: "Adicionar ramal",
        },
        toasts: {
          deleted: "Ramal excluido com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir ramal",
          deleteMessage: "Voc\u00ea tem certeza? Essa a\u00e7\u00e3o não pode ser revertida.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas R\u00e1pidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta R\u00e1pida",
          actions: "A\u00e7\u00f5es",
        },
        buttons: {
          add: "Adicionar Resposta R\u00e1pida",
        },
        toasts: {
          deleted: "Resposta R\u00e1pida exclu\u00edda com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Voc\u00ea tem certeza que quer excluir esta Resposta R\u00e1pida: ",
          deleteMessage: "Esta a\u00e7\u00e3o n\u00e3o pode ser revertida.",
        },
      },
      users: {
        title: "Usu\u00e1rios",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          status: "Status",
          whatsapp: "Conex\u00e3o Padr\u00e3o",
          sipUser: "Conta SIP",
          sipStatus: "Status SIP",
          supervisor: "Supervisor",
          actions: "Ações",
        },
        supervisor: {
          enabled: "Ativo",
          disabled: "Inativo",
        },
        buttons: {
          add: "Adicionar usu\u00e1rio",
          refresh: "Atualizar",
          disconnect: "Desconectar usu\u00e1rio",
        },
        presence: {
          online: "Online",
          away: "Ausente",
          offline: "Offline",
        },
        sipStatus: {
          unavailable: "Indisponivel",
          registered: "Registrado",
          offline: "Offline",
        },
        toasts: {
          deleted: "Usu\u00e1rio excluido com sucesso.",
          disconnected: "Usu\u00e1rio desconectado com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usu\u00e1rio serao perdidos. Os tickets abertos deste usu\u00e1rio serao movidos para a fila.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza que deseja encerrar a sess\u00e3o deste usu\u00e1rio agora?",
        },
      },
      settings: {
        success: "Configura\u00e7\u00f5es salvas com sucesso.",
        title: "Configura\u00e7\u00f5es",
        settings: {
          userCreation: {
            name: "Cria\u00e7\u00e3o de usu\u00e1rio",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuido a:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      ticketActions: {
        wabaCall: {
          request: "Solicitar permiss\u00e3o",
          requestPermission: "Solicitar permiss\u00e3o",
          requestHelp:
            "Cliente ainda n\u00e3o permitiu receber chamadas. Solicite a permiss\u00e3o oficial pela Meta.",
          pending: "Solicitar liga\u00e7\u00e3o",
          pendingHelp:
            "Cliente ainda n\u00e3o permitiu receber chamadas. Solicite a permiss\u00e3o oficial de liga\u00e7\u00e3o.",
          requestSent: "Solicita\u00e7\u00e3o de permiss\u00e3o enviada pela Meta.",
          permissionConfirmed:
            "Permiss\u00e3o confirmada. Voc\u00ea j\u00e1 pode iniciar a liga\u00e7\u00e3o.",
          permissionDeclined: "O cliente n\u00e3o autorizou chamadas agora.",
          permissionRateLimited:
            "Limite de solicita\u00e7\u00f5es da Meta atingido para este cliente.",
          permissionTitle: "Permiss\u00e3o para ligar",
          permissionBody:
            "Este cliente ainda n\u00e3o permitiu receber chamadas da empresa pelo WhatsApp. Envie a solicita\u00e7\u00e3o oficial de permiss\u00e3o da Meta para liberar o bot\u00e3o de chamada.",
          permissionRules:
            "Regra Meta: permiss\u00e3o v\u00e1lida por 7 dias ap\u00f3s aceita\u00e7\u00e3o. Solicita\u00e7\u00f5es usadas nesta janela: {{count}}/{{limit}}.",
          permissionStatus: {
            title: "Resumo da permiss\u00e3o",
            grantedTemporary: "Permitido",
            grantedPermanent: "Permitido",
            requested: "Solicitado",
            declined: "Recusado",
            rateLimited: "Limite atingido",
            noPermission: "Sem permiss\u00e3o",
            validUntil: "Permiss\u00e3o v\u00e1lida at\u00e9 {{date}}.",
            permanentHelp:
              "O cliente permitiu chamadas da empresa sem prazo definido.",
            requestedHelp:
              "A solicita\u00e7\u00e3o oficial foi enviada. Aguarde a resposta do cliente no WhatsApp.",
            declinedHelp:
              "O cliente n\u00e3o autorizou chamadas agora. Respeite o bloqueio antes de nova tentativa.",
            rateLimitedHelp:
              "A Meta bloqueou novas solicita\u00e7\u00f5es neste per\u00edodo para evitar abuso.",
            noPermissionHelp:
              "Este cliente ainda n\u00e3o autorizou chamadas da empresa pelo WhatsApp.",
            requestsUsed: "Solicita\u00e7\u00f5es usadas",
            requestsCount: "{{count}}/{{limit}} em 7 dias",
            window: "Janela de contagem",
            nextRequest: "Pr\u00f3xima tentativa",
            action: "A\u00e7\u00e3o dispon\u00edvel",
            callAllowed: "Ligar agora",
            requestAllowed: "Solicitar permiss\u00e3o",
            requestBlocked: "Aguardar libera\u00e7\u00e3o"
          },
          declinedHelp:
            "O cliente n\u00e3o autorizou receber chamadas. Este aviso permanece por 24h antes de nova tentativa.",
          rateLimitedHelp:
            "A Meta permite no m\u00e1ximo 2 solicita\u00e7\u00f5es em 7 dias para este cliente.",
          nextRequestAt: "Nova tentativa em",
          validUntil: "V\u00e1lida at\u00e9",
          openPermissionHelp:
            "Clique para ver a permiss\u00e3o de chamada deste cliente e solicitar autoriza\u00e7\u00e3o se necess\u00e1rio.",
          templateRequired: "Enviar template WABA",
          templateRequiredHelp:
            "A janela WABA de 24h expirou. Envie um template WABA para reabrir a conversa antes de pedir para o cliente nos ligar.",
          call: "Ligar",
          callHelp:
            "A permiss\u00e3o oficial est\u00e1 dispon\u00edvel. Clique para iniciar a chamada pelo WhatsApp.",
          callSoon:
            "Permiss\u00e3o concedida. A origina\u00e7\u00e3o SIP pela plataforma ser\u00e1 conectada na pr\u00f3xima etapa.",
          callStarted:
            "Chamada iniciada. Atenda seu ramal para ligar para o cliente pelo WhatsApp.",
          confirmTitle: "Iniciar liga\u00e7\u00e3o pelo WhatsApp",
          confirmBody:
            "Seu ramal SIP ser\u00e1 chamado primeiro. Depois que voc\u00ea atender, o AltChat ligar\u00e1 para o cliente pelo WhatsApp.",
          confirmCancel: "Cancelar",
          confirmStart: "Iniciar liga\u00e7\u00e3o",
          extensionUnavailable: "Ramal indispon\u00edvel",
          extensionUnavailableHelp:
            "Seu ramal SIP precisa estar dispon\u00edvel para iniciar ou receber chamadas.",
          inCall: "Em liga\u00e7\u00e3o",
          inCallHelp:
            "J\u00e1 existe uma chamada WhatsApp em andamento neste atendimento."
        }
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas r\u00e1pidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        dropHint: "Solte o arquivo para anexar",
        dropTooManyFiles: "Só os 5 primeiros arquivos foram anexados.",
      },
      internalTickets: {
        labels: {
          priority: { low: "Baixa", medium: "Media", high: "Alta", urgent: "Urgente" },
          status: { open: "Aberto", in_progress: "Em andamento", waiting: "Aguardando terceiro", done: "Concluido", cancelled: "Cancelado" },
          sla: { unscheduled: "Sem SLA", on_time: "No prazo", due_soon: "Vence em breve", overdue: "Vencido", completed: "Concluido" },
        },
        page: {
          title: "Tickets internos",
          buttons: { new: "Novo ticket interno", refresh: "Atualizar", clearFilters: "Limpar filtros", openAttendance: "Abrir atendimento", edit: "Editar" },
          intro: { title: "Opera\u00e7\u00e3o interna vinculada a clientes e atendimentos", subtitle: "Monitore SLA, prioridade e respons\u00e1vel sem misturar a execução interna com a conversa do cliente." },
          metrics: { total: "Tickets internos", dueSoon: "Vencendo em breve", overdue: "Vencidos" },
          filters: { search: "Buscar", status: "Status", allActive: "Todos (ativos)", all: "Todos", mine: "Meus tickets internos", unassigned: "Sem respons\u00e1vel" },
          card: { noDescription: "Sem descri\u00e7\u00e3o adicional.", linkedTicket: "Atendimento vinculado", linkedClient: "Cliente vinculado", noLink: "Sem v\u00ednculo com cliente ou atendimento", responsible: "Respons\u00e1vel", notDefined: "N\u00e3o definido", slaUnset: "n\u00e3o configurado", attention: "Aten\u00e7\u00e3o" },
          empty: { filtered: "Nenhum ticket interno encontrado com os filtros atuais. Tente limpar os filtros.", default: "Nenhum ticket interno encontrado." },
        },
        dialog: {
          title: { add: "Novo ticket interno", edit: "Editar ticket interno" },
          meta: { protocol: "Protocolo", client: "Cliente", attendance: "Atendimento", notLinked: "n\u00e3o vinculado" },
          fields: { noName: "Sem nome", linkedTicket: "Atendimento vinculado", ticketId: "Atendimento (ID opcional)", client: "Cliente (opcional)", title: "T\u00edtulo", priority: "Prioridade", description: "Descri\u00e7\u00e3o", status: "Status", responsible: "Respons\u00e1vel", noResponsible: "Sem respons\u00e1vel", finalComment: "Coment\u00e1rio final", newComment: "Novo coment\u00e1rio" },
          helpers: { ticketId: "Preencha se quiser vincular a um atendimento especifico.", client: "Busque por nome, número ou documento (mínimo 2 caracteres).", finalCommentRequired: "Obrigat\u00f3rio para concluir o ticket interno.", finalCommentOptional: "Opcional para complementar o encerramento." },
          placeholders: { finalComment: "Descreva o encerramento para registrar no histórico." },
          sections: { comments: "Coment\u00e1rios", history: "Histórico" },
          quickComments: { customerReturn: "Aguardando retorno do cliente", thirdParty: "Aguardando fornecedor/terceiro", technicalReview: "Em analise tecnica", waitingValidation: "Ação executada, aguardando valida\u00e7\u00e3o", internalAlignment: "Necessario novo alinhamento interno" },
          history: { loading: "Carregando histórico...", system: "Sistema", field: "Campo", empty: "vazio", noEvents: "Ainda não ha eventos registrados." },
          toasts: { missingTitle: "Informe um título para o ticket interno.", missingResponsible: "Defina um respons\u00e1vel antes de concluir o ticket interno.", missingFinalComment: "Adicione um coment\u00e1rio final para concluir o ticket interno.", missingLink: "Vincule o ticket interno a um atendimento e/ou cliente.", updated: "Ticket interno atualizado.", created: "Ticket interno criado.", missingComment: "Informe um coment\u00e1rio para adicionar no histórico.", commentAdded: "Coment\u00e1rio adicionado." },
          buttons: { cancel: "Cancelar", okAdd: "Criar ticket interno", okEdit: "Salvar alterações", addComment: "Adicionar coment\u00e1rio" },
        },
      },
      tags: {
        title: "Tags",
        table: {
          name: "Nome",
          color: "Cor",
          actions: "Ações",
        },
        buttons: {
          add: "Nova tag",
        },
        toasts: {
          deleted: "Tag removida com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Remover tag {{name}}?",
          deleteMessage: "Essa a\u00e7\u00e3o remove a tag do cadastro e dos tickets vinculados.",
        },
      },
      tagModal: {
        title: {
          add: "Nova tag",
          edit: "Editar tag",
        },
        form: {
          name: "Nome",
          color: "Cor",
        },
        buttons: {
          okAdd: "Criar tag",
          okEdit: "Salvar alterações",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
      },
      ticketSubjects: {
        title: "Assuntos do Chamado",
        table: {
          subject: "Assunto",
          status: "Status",
          dashboard: "Dashboard",
          actions: "Ações",
        },
        buttons: {
          add: "Novo assunto",
        },
        status: {
          active: "Ativo",
          inactive: "Inativo",
        },
        dashboard: {
          count: "Conta",
          ignore: "Ignorar",
        },
        toasts: {
          deleted: "Assunto removido com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Remover assunto {{name}}?",
          deleteMessage: "Essa a\u00e7\u00e3o remove o assunto da lista de encerramento.",
        },
      },
      ticketSubjectModal: {
        title: {
          add: "Novo assunto",
          edit: "Editar assunto - ID #{{id}}",
        },
        form: {
          subject: "Assunto",
          active: "Ativo",
          countInDashboard: "Contabilizar no dashboard",
        },
        buttons: {
          okAdd: "Criar assunto",
          okEdit: "Salvar alterações",
          cancel: "Cancelar",
        },
        success: "Assunto salvo com sucesso.",
      },
      contactDrawer: {
        header: "Dados do contato",
        mainInfo: "Dados cadastrais",
        personType: "Tipo de cadastro",
        document: "CPF/CNPJ",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informa\u00e7\u00f5es",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Aten\u00e7\u00e3o! Todas as mensagens relacionadas ao ticket ser\u00e3o perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        edit: "Editar",
        delete: "Deletar",
        reply: "Responder",
        editTitle: "Editar mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        edited: "Editada",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta a\u00e7\u00e3o n\u00e3o pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_WEBCHAT_HANDOFF_DISABLED: "O envio para o WebChat n\u00e3o est\u00e1 ligado nesta conex\u00e3o. Ative em Conex\u00f5es, na conex\u00e3o do WhatsApp oficial.",
        ERR_WEBCHAT_HANDOFF_TARGET_INVALID: "A conex\u00e3o de WebChat escolhida n\u00e3o existe mais ou foi arquivada. Escolha outra nas configura\u00e7\u00f5es da conex\u00e3o.",
        ERR_WEBCHAT_HANDOFF_TARGET_REQUIRED: "Para ligar o envio para o WebChat, escolha qual WebChat recebe a conversa.",
        ERR_WEBCHAT_HANDOFF_NOT_OFFICIAL: "O link do WebChat s\u00f3 existe em conex\u00f5es da API oficial do WhatsApp.",
        ERR_WEBCHAT_HANDOFF_TICKET_CLOSED: "Este chamado est\u00e1 encerrado.",
        ERR_WEBCHAT_HANDOFF_ALREADY_IN_WEBCHAT: "O cliente j\u00e1 abriu o link e est\u00e1 no WebChat. Continue a conversa por l\u00e1.",
        ERR_WEBCHAT_HANDOFF_SENDING: "O link ainda est\u00e1 sendo enviado. Aguarde alguns segundos e confira a conversa.",
        ERR_CONTACT_APP_NUMBER_LOCKED: "Este contato foi aberto pelo app do assinante. O n\u00famero dele n\u00e3o pode ser alterado.",
        ERR_INVALID_TOKEN_SCOPE: "Tipo de token inv\u00e1lido.",
        ERR_WEBCHAT_APP_ONLY_IS_HANDOFF_TARGET: "Este WebChat recebe o link de continua\u00e7\u00e3o de uma conex\u00e3o do WhatsApp oficial. Escolha outro WebChat l\u00e1 antes de ligar \"S\u00f3 conversas abertas pelo app\", ou crie uma conex\u00e3o s\u00f3 para o app.",
        ERR_WEBCHAT_HANDOFF_GROUP: "N\u00e3o d\u00e1 para enviar o link do WebChat em conversa de grupo.",
        ERR_WEBCHAT_HANDOFF_NO_NUMBER: "Este contato n\u00e3o tem n\u00famero de WhatsApp v\u00e1lido.",
        ERR_WEBCHAT_HANDOFF_INSECURE_URL: "O endere\u00e7o p\u00fablico do servidor n\u00e3o usa https. Por seguran\u00e7a, o link do WebChat n\u00e3o \u00e9 enviado assim.",
        ERR_WEBCHAT_HANDOFF_NO_PUBLIC_URL: "O endere\u00e7o p\u00fablico do servidor n\u00e3o est\u00e1 configurado (BACKEND_URL).",
        ERR_WEBCHAT_MEDIA_UNSUPPORTED: "O WebChat ainda n\u00e3o envia arquivos, fotos ou \u00e1udios. Mande o conte\u00fado como texto ou link.",
        ERR_NO_MESSAGE_FOUND: "Mensagem n\u00e3o encontrada.",
        ERR_MESSAGE_TOO_LONG: "A mensagem editada ultrapassa o limite permitido.",
        ERR_MESSAGE_EDIT_NOT_ALLOWED: "Esta mensagem n\u00e3o pode ser editada.",
        ERR_MESSAGE_EDIT_WINDOW_EXPIRED: "O WhatsApp n\u00e3o permite mais editar esta mensagem.",
        ERR_MESSAGE_EDIT_TYPE_NOT_SUPPORTED: "Este tipo de mensagem n\u00e3o pode ser editado.",
        ERR_MESSAGE_EDIT_UNCHANGED: "O texto editado n\u00e3o possui altera\u00e7\u00f5es.",
        ERR_MESSAGE_EDIT_CHANNEL_NOT_SUPPORTED: "Este canal n\u00e3o oferece suporte \u00e0 edi\u00e7\u00e3o de mensagens.",
        ERR_MESSAGE_DELETE_NOT_ALLOWED: "Esta mensagem n\u00e3o pode ser exclu\u00edda.",
        ERR_MESSAGE_DELETE_CHANNEL_NOT_SUPPORTED: "Este canal n\u00e3o oferece suporte \u00e0 exclus\u00e3o de mensagens.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padr\u00e3o.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padr\u00e3o encontrado. Verifique a p\u00e1gina de conex\u00f5es.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sess\u00e3o do WhatsApp n\u00e3o foi inicializada. Verifique a p\u00e1gina de conex\u00f5es.",
        ERR_WAPP_CHECK_CONTACT:
          "N\u00e3o foi poss\u00edvel verificar o contato do WhatsApp. Verifique a p\u00e1gina de conex\u00f5es",
        ERR_WAPP_INVALID_CONTACT: "Este n\u00e3o \u00e9 um n\u00famero de Whatsapp v\u00e1lido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "N\u00e3o foi poss\u00edvel baixar m\u00eddia do WhatsApp. Verifique a p\u00e1gina de conex\u00f5es.",
        ERR_INVALID_CREDENTIALS:
          "Usu\u00e1rio ou senha inv\u00e1lidos.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a conex\u00e3o ou o formato da m\u00eddia.",
        ERR_DELETE_WAPP_MSG: "N\u00e3o foi poss\u00edvel excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "J\u00e1 existe um t\u00edquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sess\u00e3o expirada. Por favor entre.",
        ERR_CANNOT_DISCONNECT_SELF:
          "N\u00e3o \u00e9 poss\u00edvel desconectar o pr\u00f3prio usu\u00e1rio por esta a\u00e7\u00e3o.",
        ERR_USER_CREATION_DISABLED:
          "A cria\u00e7\u00e3o do usu\u00e1rio foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Voc\u00ea n\u00e3o tem permiss\u00e3o para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "J\u00e1 existe um contato com este n\u00famero.",
        ERR_CONTACT_IMPORT_FILE_REQUIRED:
          "Envie um arquivo CSV ou TXT para importar os contatos.",
        ERR_NO_SETTING_FOUND: "Nenhuma configura\u00e7\u00e3o encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum t\u00edquete encontrado com este ID.",
        ERR_NO_TAG_FOUND: "Nenhuma tag encontrada com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usu\u00e1rio encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_NO_EXTENSION_FOUND: "Nenhum ramal encontrado com este ID.",
        ERR_EXTENSION_ALREADY_EXISTS: "Ja existe um ramal com esse número.",
        ERR_EXTENSION_GLOBAL_CONFLICT:
          "Este ramal já esta em uso por outra empresa SIP ativa.",
        ERR_USER_ALREADY_HAS_ACTIVE_EXTENSION:
          "Este atendente já possui um ramal ativo.",
        ERR_SIP_PASSWORD_REQUIRED:
          "Defina a senha SIP do atendente antes de ativar/vincular o ramal.",
        ERR_EXTENSION_INVALID:
          "Ramal inv\u00e1lido. Use apenas numeros com 2 a 10 digitos.",
        ERR_SIP_EXTENSION_LIMIT_REACHED:
          "Limite de ramais SIP atingido para esta empresa.",
        ERR_NO_EXTERNAL_NUMBER_FOUND:
          "Nenhum número externo encontrado com este ID.",
        ERR_EXTERNAL_NUMBER_ALREADY_EXISTS:
          "Ja existe um número externo com esse valor.",
        ERR_EXTERNAL_NUMBER_INVALID:
          "Número externo inv\u00e1lido. Use apenas digitos com opcional + no início.",
        ERR_EXTERNAL_NUMBER_DIRECTION_INVALID:
          "Direção inválida para número externo.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar t\u00edquete no banco de dados.",
        ERR_TICKET_SUBJECT_REQUIRED:
          "Informe o assunto do chamado antes de enviar mensagens.",
        ERR_TICKET_RESOLUTION_REQUIRED:
          "Informe um breve resumo antes de resolver o chamado.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor j\u00e1 est\u00e1 em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de sauda\u00e7\u00e3o \u00e9 obrigat\u00f3rio quando h\u00e1 mais de uma fila.",
        ERR_LICENSE_EXPIRED:
          "Licenca expirada. Entre em contato com o suporte para renova\u00e7\u00e3o.",
        ERR_LICENSE_NOT_FOUND:
          "Licenca não encontrada. Verifique a LICENSE_KEY informada.",
        ERR_LICENSE_BINDING_MISMATCH:
          "Licenca vinculada a outro ambiente. Limpe o binding e valide novamente.",
          ERR_BACKEND_UNREACHABLE:
            "Não foi possível conectar ao backend. Verifique URL, porta e CORS.",
          ERR_BACKEND_HTTPS_HTTP_MISMATCH:
            "Frontend em HTTPS e backend em HTTP. Acesse por HTTP ou habilite HTTPS no backend.",
          ERR_API_TOOL_DOCUMENT_REQUIRED:
            "Esta a\u00e7\u00e3o exige CPF/CNPJ válido no contato.",
          ERR_API_TOOL_DOCUMENT_INVALID:
            "CPF/CNPJ inv\u00e1lido para esta a\u00e7\u00e3o. Revise o cadastro do contato.",
          ERR_API_TOOL_RESULT_TEMPLATE_INVALID:
            "Template de resultado inv\u00e1lido. Revise os campos Mustache usados.",
          ERR_API_TOOL_RESPONSE_MAPPING_INVALID:
            "Mapeamento de variáveis da resposta inv\u00e1lido. Revise o JSON informado.",
          ERR_API_TOOL_BODY_INVALID_JSON:
            "Body template inv\u00e1lido: JSON mal formatado ap\u00f3s aplicar as variáveis.",
        },
    },
  },
};

export { messages };




